import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Eyebrow } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const n = TESTIMONIALS.length;
  useEffect(() => {
    const t = setTimeout(() => setI((v) => (v + 1) % n), 7000);
    return () => clearTimeout(t);
  }, [i, n]);
  const t = TESTIMONIALS[i];
  return (
    <section data-testid="testimonials-section" className="bg-[#F8FAFC] py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-3 flex lg:flex-col justify-between gap-6">
          <Eyebrow>In their words</Eyebrow>
          <div className="flex items-center gap-3">
            <button data-testid="testimonial-prev" aria-label="Previous" onClick={() => setI((i - 1 + n) % n)} className="w-12 h-12 rounded-full border border-slate-300 grid place-items-center hover:bg-[#0A192F] hover:text-white hover:border-[#0A192F] transition-colors"><ArrowLeft size={18} /></button>
            <button data-testid="testimonial-next" aria-label="Next" onClick={() => setI((i + 1) % n)} className="w-12 h-12 rounded-full border border-slate-300 grid place-items-center hover:bg-[#0A192F] hover:text-white hover:border-[#0A192F] transition-colors"><ArrowRight size={18} /></button>
            <span className="font-mono-x text-sm text-slate-500 ml-2" data-testid="testimonial-counter">0{i + 1} / 0{n}</span>
          </div>
        </div>
        <div className="lg:col-span-9 relative min-h-[340px] sm:min-h-[300px] md:min-h-[320px]">
          <AnimatePresence initial={false}>
            <motion.figure key={i} data-testid="testimonial-active" className="absolute inset-0"
              initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -30 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
              <span className="font-serif-i text-8xl leading-none text-sky-600 block h-12">“</span>
              <blockquote className="text-2xl sm:text-3xl md:text-[2.6rem] font-semibold tracking-tight leading-[1.15] text-[#0A192F]">{t.quote}</blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <span className="h-px w-10 bg-sky-600" />
                <span><span className="font-bold text-[#0A192F]">{t.name}</span><span className="text-slate-500"> — {t.org}</span></span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
